<template>
  <div>
    <PaymentFormDesktop
      v-if="isDesktopView"
      :id="id"
    />
    <PaymentFormMobile
      v-if="isMobileView"
      :id="id"
    />
  </div>
</template>

<script>
import sharedComputed from '@/methods/sharedComputed'
import sharedMethods from '@/methods/sharedMethods'

import { createHelpers } from 'vuex-map-fields'
import state from '@/store/state'
import PaymentFormDesktop from '@/components/Views/Home/PaymentFormDesktop.vue'
import PaymentFormMobile from '@/components/Views/Home/PaymentFormMobile'
import articleComputed from '@/methods/articleComputed'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'PaymentFormContainer',

  metaInfo() {
    return this.getMetaTags()
  },

  props: {
    id: {
      type: String,
      default: null,
    },
  },

  components: {
    PaymentFormDesktop,
    PaymentFormMobile,
  },

  watch: {
    selectedArticle() {
      this.setArticleMeta()
    },
  },

  created() {
    this.setContentAreaWidth()
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
    ...articleComputed,
  },

  methods: {
    ...sharedMethods,
  },
}
</script>
